import { AdminList, AdminDataGrid, GridColumn } from './shared';
/**
 * Important Date List Component
 * Displays paginated list of user important dates
 */

import {
  TextField,
  DateField,
  SearchInput,
  SelectInput,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import { semantic, brand } from '@rekindle/shared/theme';
import { DATE_TYPE_CHOICES } from '../constants';
import { ListActions, UserEmailField } from './shared';

/**
 * Date type color mapping
 */
const TYPE_COLORS: Record<string, string> = {
  birthday: brand.primary,
  anniversary: brand.secondary,
  custom: semantic.info,
  holiday: semantic.success,
  reminder: semantic.warning,
};

/**
 * Custom field to display date type with color coding
 */
function TypeField() {
  const record = useRecordContext();
  if (!record?.type) return null;

  const type = record.type.toLowerCase();
  const color = TYPE_COLORS[type] || TYPE_COLORS.custom;

  return (
    <Chip
      label={record.type}
      size="small"
      sx={{
        backgroundColor: color,
        color: 'white',
        textTransform: 'capitalize',
      }}
    />
  );
}

/**
 * Filters for important date list
 */
const dateFilters = [
  <SearchInput key="q" source="q" alwaysOn placeholder="Search dates..." />,
  <SelectInput
    key="type"
    source="type"
    label="Type"
    choices={DATE_TYPE_CHOICES}
  />,
];

export function ImportantDateList() {
  return (
    <AdminList
      filters={dateFilters}
      actions={<ListActions />}
      sort={{ field: 'date', order: 'ASC' }}
      perPage={25}
    >
      <AdminDataGrid bulkActionButtons={false} rowClick="edit" omit={['id']}>
        <TextField source="id" label="ID" />
        <TextField source="title" label="Title" />
        <GridColumn label="User" source="userEmail"><UserEmailField /></GridColumn>
        <GridColumn label="Type" source="type"><TypeField /></GridColumn>
        <DateField source="date" label="Date" />
        <DateField source="createdAt" label="Created" showTime />
      </AdminDataGrid>
    </AdminList>
  );
}
